import { useMemo } from 'react';

const useIsVideo = (fileUrl) =>
  useMemo(() => {
    const videoPattern = /\.(mp4|mov)$/i;
    return videoPattern.test(fileUrl);
  }, [fileUrl]);
export default useIsVideo;
